import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "vehicle-info-page" }

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useEvCarsStore } from '@/store/ev-vehicles'

import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'

// New reorganized sections
import VehicleInfoSection from './VehicleInfoSection.vue'
import EVFeaturesSection from './EVFeaturesSection.vue'
import EVTariffSection from './EVTariffSection.vue'
// import PremiumFeaturesSection from './PremiumFeaturesSection.vue'
// import InsuranceSection from './InsuranceSection.vue'
import EvCarDamageReport from './EvCarDamageReport.vue'
import GeotekControlSection from './GeotekControlSection.vue'
import AvailabilitySection from './AvaliabilitySection.vue'
import { getEvCarDamageReports } from '@/api/car-ev-data'
// import SecurityDeposits from './SecurityDeposits.vue'
// import InsuranceOptOut from './InsuranceOptOut.vue'
// import VehiclesPOA from './VehiclesPOA.vue'
// import { useUsersStore } from '@/store/users'
import VehicleTripsSection from './VehicleTripsSection.vue'
import ReserveSection from './ReserveSection.vue'
import FinanceSection from './FinanceSection.vue'
import PortalEvCarRegistered from './PortalEvCarRegistered.vue'
import AdminCommentsSection from './AdminCommentsSection.vue'
import { useAuthStore } from '@/store/auth'

type CarTabName = typeof validTabs[number]


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const route = useRoute()
const router = useRouter()

const evCarsStore = useEvCarsStore()
const authStore = useAuthStore()

const canLockUnlock = computed(() => {
  const user = authStore.session?.user
  if (!user) return false
  return user.ev_role === 'admin' || user.ev_role === 'super_admin'
})

const validTabs = [
  'vehicle-info',
  'vehicle-trips',
  'reservations',
  'damage-report',
  'geotek-control',
  'availability',
  'finance',
  'portal-ev-car-registration',
  'admin-comments',
] as const
const normalizeCarTab = (val: unknown): CarTabName => {
  const s = Array.isArray(val) ? val[0] : String(val ?? '')
  if ((validTabs as readonly string[]).includes(s)) {
    return s as CarTabName
  }
  const saved =
    localStorage.getItem(`ev-car-details-tab-${props.id}`) ||
    localStorage.getItem('ev-car-details-active-tab')
  if (saved && (validTabs as readonly string[]).includes(saved)) {
    return saved as CarTabName
  }
  return 'vehicle-info'
}

const activeTab = ref<CarTabName>(normalizeCarTab(route.query.tab))

// URL -> UI
watch(
  () => route.query.tab,
  q => {
    const next = normalizeCarTab(q)
    if (next !== activeTab.value) activeTab.value = next
  }
)

// UI -> URL & localStorage
watch(
  activeTab,
  newTab => {
    localStorage.setItem(`ev-car-details-tab-${props.id}`, newTab)
    localStorage.setItem('ev-car-details-active-tab', newTab)
    const current = Array.isArray(route.query.tab)
      ? route.query.tab[0]
      : route.query.tab
    if (current !== newTab) {
      router.replace({
        path: route.path,
        query: {
          ...route.query,
          tab: newTab,
        },
      })
    }
  },
  { immediate: true }
)
const openedReportsCount = ref(0)

// const isCommercialHost = computed(
//   () => vehiclesStore.vehiclesDetails[props.id]?.data?.user.commercial_host
// )

const vehicle = computed(() => evCarsStore.evCarsDetails[props.id]?.data)

watch(
  vehicle,
  newVal => {
    if (newVal) {
      // const userId = newVal.user.id
      // const user = evCarsStore.evCarsDetails[props.id]?.data;
    }
  },
  { immediate: true }
)

// type vehicleDet = {
//   car_availabilities?: Array<{
//     start_date: string
//     end_date: string
//     created_at: string
//     updated_at: string
//   }>
// }

// // car_availabilities
// const preparedVehicle = computed(() => {
//   const vehicleData = (vehicle.value || {}) as vehicleDet

//   return {
//     car_availabilities: vehicleData.car_availabilities || [],
//     ...vehicleData,
//   }
// })
const getOpenedDamageReportsCount = async () => {
  try {
    const response = await getEvCarDamageReports(props.id)
    const opened = response.data.data.filter((r: any) => r.status === 'opened')
      .length
    openedReportsCount.value = opened
  } catch (error) {
    console.error('❌ Failed to fetch damage report count', error)
  }
}

const error = computed(() => evCarsStore.evCarsDetails[props.id]?.error)
const isLoading = computed(() => evCarsStore.evCarsDetails[props.id]?.isLoading)

const getVehicleDetails = () => {
  evCarsStore.getEvCarDetails(props.id)
}

onMounted(() => {
  if (!isLoading.value) {
    getVehicleDetails()
    getOpenedDamageReportsCount()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "container"
  }, {
    default: _withCtx(() => [
      (error.value)
        ? (_openBlock(), _createBlock(CommonError, {
            key: 0,
            errorMessage: error.value,
            onRetryPress: getVehicleDetails
          }, null, 8, ["errorMessage"]))
        : (!vehicle.value)
          ? (_openBlock(), _createBlock(Loader, { key: 1 }))
          : (_openBlock(), _createBlock(_component_el_tabs, {
              key: 2,
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
              type: "card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "EV Vehicle info",
                  name: "vehicle-info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(VehicleInfoSection, { vehicle: vehicle.value }, null, 8, ["vehicle"]),
                          _createVNode(EVFeaturesSection, { vehicle: vehicle.value }, null, 8, ["vehicle"]),
                          _createVNode(EVTariffSection, { vehicle: vehicle.value }, null, 8, ["vehicle"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Vehicle Trips",
                  name: "vehicle-trips",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(VehicleTripsSection, { vehicle: vehicle.value }, null, 8, ["vehicle"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "RESERVE CAR",
                  name: "reservations",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, {
                      always: "",
                      class: "tab-content-scrollbar"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ReserveSection, { vehicle: vehicle.value }, null, 8, ["vehicle"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: `EV damage reports (${openedReportsCount.value})`,
                  name: "damage-report",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(EvCarDamageReport, {
                          vehicle: vehicle.value,
                          onUpdateOpenedCount: _cache[0] || (_cache[0] = ($event: any) => (openedReportsCount.value = $event))
                        }, null, 8, ["vehicle"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]),
                (canLockUnlock.value)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 0,
                      label: "EV Geotek control",
                      name: "geotek-control"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_scrollbar, { always: "" }, {
                          default: _withCtx(() => [
                            _createVNode(GeotekControlSection, { vehicle: vehicle.value }, null, 8, ["vehicle"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_tab_pane, {
                  label: "EV Сar availabilities",
                  name: "availability"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(AvailabilitySection, {
                          vehicleId: props.id
                        }, null, 8, ["vehicleId"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Finance",
                  name: "finance",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(FinanceSection, {
                          carId: props.id
                        }, null, 8, ["carId"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Portal EV Car Registration",
                  name: "portal-ev-car-registration",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(PortalEvCarRegistered, { vehicle: vehicle.value }, null, 8, ["vehicle"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Logs & Comments",
                  name: "admin-comments",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(AdminCommentsSection, {
                          comments: vehicle.value?.admin_comment || []
                        }, null, 8, ["comments"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
    ]),
    _: 1
  }))
}
}

})